module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tooltip', {
    ref: "tooltip",
    attrs: {
      "placement": "top",
      "popper-class": "absence-tooltip-container",
      "open-delay": 100,
      "enterable": false,
      "visible-arrow": false,
      "effect": "light"
    }
  }, [_c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "absence-tooltip"
  }, [_c('div', {
    staticClass: "tooltip-top"
  }, [_c('div', {
    staticClass: "tooltip-top-left"
  }, [(_vm.displayInfo.typeIcon == 'conge') ? _c('span', {
    staticClass: "icon-mask",
    style: ({
      backgroundColor: _vm.display.color
    })
  }) : _c('i', {
    class: _vm.displayInfo.typeIcon,
    style: ({
      color: _vm.display.color
    })
  }), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.display.color
    })
  }, [_vm._v(_vm._s(_vm.display.libelleTooltip))])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-top-right"
  }, [_c('span', {
    staticClass: "date-range"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.absence.DateDebut, "DD/MM/YY")) + " "), _c('i', {
    staticClass: "ri-arrow-right-line"
  }), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.absence.DateFin, "DD/MM/YY")))]), _vm._v(" "), _c('span', {
    staticClass: "date-duration"
  }, [_vm._v(" - " + _vm._s(_vm.getDuration()))])])]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-bottom"
  }, [_c('i', {
    class: _vm.displayInfo.stateInfo.icon,
    style: ({
      color: _vm.display.color
    })
  }), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.display.color
    })
  }, [_vm._v(_vm._s(_vm.displayInfo.stateInfo.title))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.onAbsenceClickedOutside),
      expression: "onAbsenceClickedOutside"
    }],
    staticClass: "absence-line absence-line-equipe",
    class: [_vm.borderRadiusClass(), 'absence-group-' + _vm.absence.Id, {
      'absence-anonymized': _vm.isAnonymized && !_vm.isEditable
    }, {
      'absence-no-clickable': !_vm.isEditable
    }],
    style: (_vm.barStyle),
    on: {
      "mouseenter": _vm.onAbsenceMouseEnter,
      "mouseleave": _vm.onAbsenceMouseLeave,
      "click": _vm.onAbsenceClicked
    }
  }, [(_vm.showText) ? [_c('div', {
    staticClass: "absence-detail"
  }, [_c('div', {
    staticClass: "detail-type-icon"
  }, [(_vm.displayInfo.typeIcon == 'conge') ? _c('span', {
    staticClass: "icon-mask",
    style: ({
      backgroundColor: _vm.displayInfo.style.color
    })
  }) : _c('i', {
    class: _vm.displayInfo.typeIcon
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-type-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.display.libelle))])]), _vm._v(" "), _c('div', {
    staticClass: "absence-date"
  }, [_c('span', {
    staticClass: "date-range"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.absence.DateDebut, "DD/MM/YY")) + " "), _c('i', {
    staticClass: "ri-arrow-right-line"
  }), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.absence.DateFin, "DD/MM/YY")))]), _vm._v(" "), _c('span', {
    staticClass: "date-duration"
  }, [_vm._v(_vm._s(_vm.getDuration()))])]), _vm._v(" "), (!_vm.isAnonymized && _vm.isEditable) ? _c('div', {
    staticClass: "etat-icon"
  }, [_c('i', {
    class: _vm.displayInfo.stateInfo.icon
  })]) : _vm._e(), _vm._v(" "), (!_vm.isAnonymized && _vm.isEditable) ? _c('div', {
    staticClass: "etat-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.displayInfo.stateInfo.title))])]) : _vm._e(), _vm._v(" "), (!_vm.isAnonymized && _vm.isEditable) ? _c('div', {
    staticClass: "menu"
  }, [_c('el-popover', {
    ref: "menuPopover",
    attrs: {
      "popper-class": "planning-mensuel-menu-popper",
      "placement": "top",
      "width": 280,
      "trigger": "manual"
    },
    model: {
      value: (_vm.menuPopoverVisible),
      callback: function($$v) {
        _vm.menuPopoverVisible = $$v
      },
      expression: "menuPopoverVisible"
    }
  }, [_c('el-button', {
    staticClass: "button-menu",
    attrs: {
      "slot": "reference",
      "icon": "ri-more-2-line"
    },
    on: {
      "click": function($event) {
        _vm.onTooltipHide()
      }
    },
    slot: "reference"
  }), _vm._v(" "), _vm._t("default", [_c('el-button', {
    staticClass: "historique",
    attrs: {
      "icon": "ri-zoom-in-line"
    },
    on: {
      "click": function($event) {
        _vm.openDrawerHistorique(_vm.absence)
      }
    }
  }, [_vm._v("Voir l'historique")]), _vm._v(" "), (_vm.actionsState.modifierVisible) ? _c('el-button', {
    staticClass: "modifier",
    attrs: {
      "icon": "ri-pencil-line"
    },
    on: {
      "click": _vm.modify
    }
  }, [_vm._v("Modifier l'absence")]) : _vm._e(), _vm._v(" "), (!_vm.actionsState.annulerDisabled) ? _c('el-button', {
    staticClass: "annuler",
    attrs: {
      "icon": "ri-delete-bin-line"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Annuler l'absence")]) : _vm._e(), _vm._v(" "), (_vm.actionsState.supprimerDemandeAnnulationVisible) ? _c('el-button', {
    staticClass: "annuler-annulation",
    attrs: {
      "icon": "ri-close-line"
    },
    on: {
      "click": _vm.cancelCancellation
    }
  }, [_vm._v("Annuler la demande d'annulation")]) : _vm._e()])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dots"
  }, [_c('span', [_vm._v("...")])])]), _vm._v(" "), (_vm.drawerIsVisible) ? _c('side-panel-historique', {
    attrs: {
      "absence": _vm.drawerAbsence
    },
    on: {
      "close": function($event) {
        _vm.drawerIsVisible = false
      }
    }
  }) : _vm._e()] : _vm._e()], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-396e8e0d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsencesV2/calendrierEquipe/absencePlanningEquipe/absencePlanningEquipe.vue.html
// module id = cmBg
// module chunks = 2